const getDropItemStyles = (isHovered = false) => {
  const background = isHovered ? 'grey100' : 'grey000White'
  const borderColor = 'grey400'

  return {
    background,
    borderColor,
  }
}

export default getDropItemStyles
